import gql from 'graphql-tag'
export const GET_MODULES = gql`
  query {
    modulo {
      _id
      cursos
      grupos
      forum
      closedAt
    }
  }
`
